import React from "react";
import styled from "styled-components";
import { FaArrowUp } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";


const AccuracyBadgeWithTooltip = ({
  accuracy,
  increase,
  tooltipText,
  className,
}) => {
  /* unique per instance - a shared id makes every badge on the page
     open at once */
  const tooltipId = `deep-verify-accuracy-tooltip-${React.useId()}`;

  return (
    <>
      <BadgeWrapper
        className={className}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipText}
        data-tooltip-place="bottom"
      >
        <AccuracyBox>
          <ArrowIconWrap>
            <div>
      <FaArrowUp size={19} color="#2ecc71" />
    </div>
          </ArrowIconWrap>
          <AccuracyText>{accuracy}</AccuracyText>
        </AccuracyBox>

        <IncreaseBox>{increase}</IncreaseBox>
      </BadgeWrapper>

      <StyledTooltip id={tooltipId}  place="bottom" offset={10} />
    </>
  );
};

export default AccuracyBadgeWithTooltip;

const BadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 5px;
  background: rgb(42 69 96);
  width: fit-content;
  cursor: pointer;
`;

const AccuracyBox = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 6px;
  color: #ffffff;
`;

const ArrowIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const AccuracyText = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
`;

const IncreaseBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 4px;
  border-radius: 4px;
  background: #48d67b;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
`;

const StyledTooltip = styled(Tooltip)`
  max-width: 340px !important;
  background-color: #1f2937 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 10px 12px !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  z-index: 9999 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
`;